<template>
  <div class="box-wrapper">
    <div class="box" :style="[boxStyles]">
      <slot />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'moodal-wrapper',
  props: {
    boxStyles: {
      type: Object,
      default: () => ({}),
    },
  },
});
</script>

<style scoped>
.box-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  position: relative;
}
.box {
  background-color: #fff;
  border-radius: 20px;
  width: 100%;
  max-width: var(--page-container-width, 1260px);
  padding: 60px;
}
</style>
